import React, { forwardRef, Fragment } from 'react';
import { FormatCurrency } from "../../GlobalScript";
import Table from 'react-bootstrap/Table';

const PrintableOrder = forwardRef((
    {
        orderItems,
        orderName,
        orderDate,
        orderType,
        orderBy,
        kCode,
        shipTo,
        shipMethod,
        partsTotal,
        accTotal,
        otherTotal,
        estFreight,
        estHandling,
        estSpecialFee,
        grandTotal,
        orderID,
        tracking
    }, ref) => {

    const trackingLookup =
        tracking?.trackings?.reduce((acc, tracking) => {
            acc[tracking.sku] = tracking;
            return acc;
        }, {}) || {};

    return (
        <div className="print-container" ref={ref}>
            {shipTo && 
                <Table bordered>
                    <tbody>
                        <tr>
                            <td className="text-center">
                                <h3>Order Information</h3>
                            </td>
                            <td className="text-center">
                                <h3>Shipping Information</h3>
                            </td>
                            <td className="text-center">
                                <h3>Shipping Method</h3>
                            </td>
                        </tr>
                        <tr>
                            <td>Order #: {orderID}</td>
                            <td>{shipTo.firstName}</td>
                            <td>{shipMethod}</td>
                        </tr>
                        <tr>
                            <td>Order Name: {orderName}</td>
                            <td>{shipTo.address} {shipTo.city}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Order Date: {orderDate}</td>
                            <td>{shipTo.stateCode} {shipTo.zipCode}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Order Type: {orderType}</td>
                            <td>{shipTo.countryCode}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Ordered By: {orderBy}</td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </Table>}
           

            <Table>
                <tbody>
                    <tr>
                        <td><span className="svg-holder"><img src="../../../Images/parts.svg" alt="" width="20" /> Parts</span></td>
                        <td><span className="svg-holder"><img src="../../../Images/accessories.svg" alt="" width="20" /> Accessories</span></td>
                        <td><span className="svg-holder"><img src="../../../Images/other.svg" alt="" width="20" /> Other</span></td>
                        <td><span className="svg-holder"><img src="../../../Images/partially-shipped.svg" alt="" width="20" /> Partially Shipped</span></td>
                        <td><span className="svg-holder"><img src="../../../Images/shipped-active.svg" alt="" width="20" /> Shipped</span></td>
                        <td><span className="svg-holder"><img src="../../../Images/returned.svg" alt="" width="20" /> Returned</span></td>
                        <td><span className="svg-holder"><img src="../../../Images/Allocated.svg" alt="" width="20" /> Allocated</span></td>
                        <td><span className="svg-holder"><img src="../../../Images/queued.svg" alt="" width="20" /> Queued</span></td>
                        <td><span className="svg-holder"><img src="../../../Images/cancelled-inactive.svg" alt="" width="20" /> Cancelled</span></td>
                        <td><span className="svg-holder"><img src="../../../Images/backorder.svg" alt="" width="20" /> Backorder</span></td>
                    </tr>
                </tbody>
            </Table>

            <div className="order-table">
                <Table className="compact-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>PRODUCT</th>
                            <th>TRACKING</th>
                            <th>MEMO</th>
                            <th>ITEM <br /> TYPE</th>
                            <th>STATUS</th>
                            <th width="8%">QTY</th>
                            <th>BKORD <br /> QTY</th>
                            <th>UNIT <br /> PRICE</th>
                            <th>SUBTOTAL</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.from(orderItems.values()).map((d, index) => {
                            const trackingInfo = trackingLookup[d.sku];

                            return (
                                <Fragment key={"sku" + index.toString()}>
                                    <tr>
                                        <td>{index + 1}</td>
                                        <td className="text-left">
                                            {d.desc} <br />
                                            Item No: {d.sku}
                                        </td>
                                        <td>
                                            {trackingInfo?.tracking &&
                                                <>
                                                    {trackingInfo.tracking}
                                                </>
                                            }
                                        </td>
                                        <td>{d.memo}</td>
                                        <td>
                                            <span className="svg-holder small-svg">
                                                <img src={"../../../Images/" + d.inventoryTypeImg} alt={d.inventoryTypeImg} />
                                            </span>
                                        </td>
                                        <td>
                                            <span className="svg-holder small-svg">
                                                <img src={"../../../Images/" + d.statusImg} alt={d.statusImg} />
                                            </span>
                                        </td>
                                        <td>{d.qty}</td>
                                        <td>{d.boQty}</td>
                                        <td>{FormatCurrency(d.unitPrice)}</td>
                                        <td>{FormatCurrency(d.unitPrice * (d.qty + d.boQty))}</td>
                                    </tr>
                                </Fragment>
                            )
                        })}
                    </tbody>
                </Table>

                <Table className="compact-table">
                    <tbody>
                        <tr>
                            <td>Parts Subtotal:</td>
                            <td>
                                {FormatCurrency(partsTotal)}
                            </td>
                        </tr>
                        <tr>
                            <td>Acc Subtotal:</td>
                            <td>
                                {FormatCurrency(accTotal)}
                            </td>
                        </tr>
                        <tr>
                            <td>Other Subtotal:</td>
                            <td>
                                {FormatCurrency(otherTotal)}
                            </td>
                        </tr>
                        <tr>
                            <td>Est Freight:</td>
                            <td>
                                {FormatCurrency(estFreight)}
                            </td>
                        </tr>
                        <tr>
                            <td>Est Handling:</td>
                            <td>
                                {FormatCurrency(estHandling)}
                            </td>
                        </tr>
                        <tr>
                            <td>Est Special Fee:</td>
                            <td>
                                {FormatCurrency(estSpecialFee)}
                            </td>
                        </tr>
                        <tr>
                            <td>K-Code:</td>
                            <td>
                                {kCode ? kCode : 'N/A'}
                            </td>
                        </tr>
                        <tr>
                            <td className="bold">Total:</td>
                            <td className="bold">
                                {FormatCurrency(grandTotal)}
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        </div>
    )
});

export default PrintableOrder;